import { render, staticRenderFns } from "./Vsa.vue?vue&type=template&id=c13adfc0&"
import script from "./Vsa.vue?vue&type=script&lang=js&"
export * from "./Vsa.vue?vue&type=script&lang=js&"
import style0 from "./Vsa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports